import { ScreenName } from 'lib/types';
import * as React from 'react';
import Dashboard from '../Dashboard';
import dataStewardship from '../data/data-stewardship';
import DataStewardship from '../DataStewardship';
import MatchingRules from '../MatchingRules';
import './body.css';
import withBrand, { InjectedBrandProps } from 'lib/withBrand';

interface BodyProps extends InjectedBrandProps {
	nav: ScreenName;
	onClick: () => void;
}
class Body extends React.Component<BodyProps> {
	throwBadScreenName (name: never): never; // Makes compiler exhaustively check the switch below
	throwBadScreenName (name: string): never {
		throw new Error(`Unknown screen name: ${name}`);
	}

	renderBodyComponent ()  {
		const { nav, onClick } = this.props;

		switch (nav) {
			case 'dashboard':
			case 'dashboard2':
			case 'dashboard3':
			case 'dashboard4':
			case 'dashboard4CookingShow':
			case 'dashboard5':
			case 'home':
				return <Dashboard nav={nav} navClick={onClick} />;
			case 'dashboard-auth':
			case 'dashboard-auth1':
			case 'dashboard-auth2':
			case 'dashboard-auth3':
				return <Dashboard auth nav={nav} navClick={onClick} />;
			case 'matching':
				return <MatchingRules navClick={onClick} />;
			case 'stewardship':
				return <DataStewardship navClick={onClick} sources={dataStewardship} />;
			default:
				return this.throwBadScreenName(nav);
		}
	}

	render () {
		const { brand } = this.props;
		return (
			<div className={`body ${brand.guide ? 'guide' : 'no-guide'}`}>
				{this.renderBodyComponent()}
			</div>
		);
	}
}

export default withBrand(Body);


// WEBPACK FOOTER //
// ./src/Body/index.tsx